/* eslint-disable consistent-return */
/* eslint-disable getter-return */
/* eslint-disable no-else-return */
/* eslint-disable import/no-unresolved */
import BaseElement from 'base-element'
import { css, html, styleMap, ref, createRef } from 'lit-all'
import styles from 'lib-styles'
import {
  handleize,
  formatMoney,
  getViewport,
  ensureImageSize,
  paginateArray,
} from 'lib-utils'
import { BazaarvoiceClient } from 'lib-vendor'
/* eslint-disable import/no-unresolved */

class HHProductCard extends BaseElement {
  static properties = {
    id: {
      type: Number,
      attribute: 'data-id',
    },
    url: {
      type: String,
    },
    badgeText: {
      type: String,
      attribute: 'badge-text',
    },
    available: {
      type: Boolean,
    },
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    image: {
      type: String,
    },
    imageLoading: {
      type: String,
    },
    imageHover: {
      type: String,
      attribute: 'image-hover',
    },
    compareAtPrice: {
      type: String,
      attribute: 'compare-at-price',
    },
    swatches: {
      type: Array,
    },
    price: {
      type: String,
    },
    msrp: {
      type: String,
    },
    vendor: {
      type: String,
    },
    variants: {
      type: Array,
    },
    activeIndex: {
      type: Number,
    },
    swatchesPosition: {
      type: Number,
      state: true,
    },
    options: {
      type: Array,
    },
    swatchVariants: {
      state: true,
    },
    viewport: {
      type: String,
      state: true,
    },
    activeSwatchPage: {
      state: true,
    },
    hideSwatches: {
      state: true,
    },
    hideRatings: {
      attribute: 'hide-ratings',
      type: Boolean,
    },
    rating: {
      type: Object,
    },
    hidePrice: {
      attribute: 'hide-price',
      type: Boolean,
    },
    removeSwatches: {
      attribute: 'remove-swatches',
      type: Boolean,
    },
    showSwatchesCount: {
      type: Boolean,
      attribute: 'show-swatches-count',
    },
    customRating: {
      type: Boolean,
      attribute: 'custom-rating',
    },
    activeSlide: {
      type: Number,
    },
  }

  $swatchesWrapper = createRef()

  $slRating = createRef()

  $slider = createRef()

  get swatchItemsPerPage() {
    let result = 3
    switch (this.viewport) {
      case 'mobile-small':
        result = 3
        break
      case 'mobile':
        result = 3
        break
      case 'tablet-small':
        result = 5
        break
      case 'tablet':
        result = 5
        break
      case 'desktop-small':
        result = 5
        break
      case 'desktop':
        result = 5
        break
      default:
        result = 3
    }
    const willHavePages = this.swatchVariants.length > result
    if (willHavePages) {
      result--
    }

    return result
  }

  get paginatedSwatches() {
    const hasPages = this.swatchVariants.length > this.swatchItemsPerPage
    const pagedSwatches = paginateArray(
      this.swatchVariants,
      this.swatchItemsPerPage,
      hasPages
    )
    return pagedSwatches
  }

  get activeId() {
    if (this.swatchVariants[this.activeIndex]) {
      return this.swatchVariants[this.activeIndex]?.id
    }
    return this.id
  }

  get activeAvailable() {
    if (this.swatchVariants[this.activeIndex]) {
      return this.swatchVariants[this.activeIndex]?.available
    }
    return this.available
  }

  get activeMsrp() {
    if (!this.swatchVariants[this.activeIndex]?.metafields?.custom?.msrpPrice)
      return null
    return (
      formatMoney(
        (this.swatchVariants[this.activeIndex]?.metafields?.custom?.msrpPrice ||
          0) * 100
      ) || formatMoney(this.msrpPrice * 100)
    )
  }

  get activeImage() {
    const image =
      this.swatchVariants[this.activeIndex]?.image?.src ||
      this.swatchVariants[this.activeIndex]?.featuredImage ||
      this.swatchVariants[this.activeIndex]?.featured_image?.src ||
      this.image ||
      ''
    return (
      ensureImageSize(image, 704) || window.__THEME_GLOBALS__.noImagePlaceholder
    )
  }

  // eslint-disable-next-line consistent-return
  get activeVariantURL() {
    if (this.swatchVariants?.length) {
      const urlObj = new URL(
        this.url.includes('https://')
          ? this.url
          : window.location.origin + this.url
      )
      urlObj.searchParams.set(
        'variant',
        this.swatchVariants[this.activeIndex]?.id
      )
      return urlObj.toString()
    }
  }

  get activeUrl() {
    return (
      this.swatchVariants[this.activeIndex]?.variant_url ||
      this.swatchVariants[this.activeIndex]?.url ||
      this.activeVariantURL ||
      this.url
    )
  }

  get activeTitle() {
    return this.swatchVariants[this.activeIndex]?.swatchTitle || false
  }

  get activePrice() {
    if (!this.swatchVariants.length) return formatMoney(this.price)
    return formatMoney(this.swatchVariants[this.activeIndex]?.price)
  }

  get activeCompareAtPrice() {
    if (this.variants?.length > 1) {
      const activeVariant = this.swatchVariants[this.activeIndex]
      const _activeCompareAtPrice = parseFloat(
        activeVariant?.compare_at_price ||
          activeVariant?.compareAtPrice ||
          this.compareAtPrice
      )
      const _activePrice = parseFloat(activeVariant?.price || this.price)

      if (!_activeCompareAtPrice) return false
      if (_activeCompareAtPrice > _activePrice) {
        return formatMoney(_activeCompareAtPrice)
      }
    } else {
      if (!this.compareAtPrice) return false
      if (parseFloat(this.compareAtPrice) > parseFloat(this.price)) {
        return formatMoney(this.compareAtPrice)
      }
    }
    return false
  }

  get savingsAmount() {
    if (this.variants?.length > 1) {
      const activeVariant = this.swatchVariants[this.activeIndex]
      const _activeCompareAtPrice = parseFloat(
        activeVariant?.compare_at_price ||
          activeVariant?.compareAtPrice ||
          this.compareAtPrice
      )
      const _activePrice = parseFloat(activeVariant?.price || this.price)

      if (!_activeCompareAtPrice) return false
      if (
        _activeCompareAtPrice > _activePrice &&
        _activeCompareAtPrice - _activePrice > 100
      ) {
        return formatMoney(
          Math.floor((_activeCompareAtPrice - _activePrice) / 100) * 100
        )
      }
    } else {
      if (!this.compareAtPrice) return false
      if (
        parseFloat(this.compareAtPrice) > parseFloat(this.price) &&
        parseFloat(this.compareAtPrice) - parseFloat(this.price) > 100
      ) {
        return formatMoney(
          Math.floor(
            (parseFloat(this.compareAtPrice) - parseFloat(this.price)) / 100
          ) * 100
        )
      }
    }
    return false
  }

  get variantBadge() {
    return (
      this.swatchVariants[this.activeIndex]?.metafields?.custom?.budge || ''
    )
  }

  get visibleBadge() {
    return this.badgeText || this.variantBadge || ''
  }

  get badgeStyleMap() {
    const badgeHandle = handleize(this.visibleBadge) || ''
    const fallbackStyle = {
      color: '#35332b',
      backgroundColor: 'white',
    }
    if (!__THEME_GLOBALS__?.badges) return fallbackStyle
    return __THEME_GLOBALS__?.badges[badgeHandle] || fallbackStyle
  }

  get pageOfActiveSwatch() {
    const activeSwatchElement = this.renderRoot.querySelector(
      `.swatch-container[active]`
    )
    const parentPage = activeSwatchElement?.closest('.color-swatch__page')
    const parentPageNumber = Number(parentPage?.dataset.page) || 0
    return parentPageNumber
  }

  async _fetchBVStatistics() {
    try {
      const reviewsData = await this.bvClient.fetchReviews([this.activeId])
      const productsWithReviewStats = reviewsData.Includes.Products
      this.rating = {
        average:
          productsWithReviewStats[this.activeId]?.ReviewStatistics
            .AverageOverallRating,
        count:
          productsWithReviewStats[this.activeId]?.ReviewStatistics
            .TotalReviewCount,
      }
    } catch (err) {
      /* eslint-disable no-console */
      console.error('Error fetching product statistics:', err)
      /* eslint-enable no-console */
    }
  }

  constructor() {
    super()
    this.activeIndex = 0
    this.variants = []
    this.swatches = []
    this.options = []
    this.swatchVariants = []
    this.swatchesPosition = 0
    this.swatchesPerSlide = 5
    this.activeSwatchPage = 0
    this.imageLoading = 'lazy'
    this.viewport = getViewport()
    this.hideRatings = window.Shopify.shop.includes('wholesale') // Hide ratings by default on wholesale store
    this.compareAtPrice = ''
    this.customRating = false
    this.bvClient = new BazaarvoiceClient()
    this.activeSlide = 0
  }

  connectedCallback() {
    super.connectedCallback()
    if (!this.rating && this.customRating) this._fetchBVStatistics()
    window.addEventListener('hh:resize-width', this._handleResize)
    document.addEventListener('hh:filter-swatch-changed', (event) => {
      this._handleFilterSwatchChanged(event.detail)
    })
    document.addEventListener('hh:experiments-ready', this._handleExperimentReady)
  }

  disconnectedCallback() {
    window.removeEventListener('hh:resize-width', this._handleResize)
    document.removeEventListener(
      'hh:filter-swatch-changed',
      this._handleFilterSwatchChanged
    )
    document.removeEventListener(
      'hh:experiments-ready',
      this._handleExperimentReady
    )
  }

  firstUpdated() {
    this.refresh()
    this._handleResize()
    this.initImagesSlider()
    // Scrolling the container to left on load to prevent weird scroll behaviour
    this._setActiveSlide()
  }

  willUpdate(changedProperties) {
    if (changedProperties.has('id') || changedProperties.has('swatches')) {
      this.refresh()
    }
  }

  updated(changedProperties) {
    if (changedProperties.has('rating') && this.$slRating.value) {
      this.$slRating.value.getSymbol = (value) => {
        const roundedRating = Math.round(this.rating.average * 2) / 2

        if (value <= roundedRating) {
          if (value === roundedRating && roundedRating % 1 !== 0) {
            return '<sl-icon name="star-half"></sl-icon>'
          } else {
            return '<sl-icon name="star-fill"></sl-icon>'
          }
        } else if (value === Math.ceil(roundedRating)) {
          if (roundedRating % 1 !== 0) {
            return '<sl-icon name="star-half"></sl-icon>'
          } else {
            return '<sl-icon name="star"></sl-icon>'
          }
        } else {
          return '<sl-icon name="star"></sl-icon>'
        }
      }
    }

    if (
      changedProperties.has('swatchVariants') ||
      changedProperties.has('activeIndex')
    ) {
      this._handleResize()
    }
  }

  refresh() {
    this._setSwatchVariants()
    this._setSwatchCount()
    this.setActiveByVariantId(this.id, true)
  }

  initImagesSlider() {
    if (!this?.$slider?.value) return
    this.activeSlide = 0
    this.$slider.value.addEventListener('scroll', () => {
      if (this.$slider.value.scrollLeft <= this.$slider.value.offsetWidth / 3) {
        this.activeSlide = 0
      } else this.activeSlide = 1
    })
  }

  _handleResize = () => {
    this.viewport = getViewport()
    this.swatchesPosition = 0
    const infoWidth = this.renderRoot.querySelector('#info')?.clientWidth
    if (infoWidth <= 150) {
      this.hideSwatches = true
    } else {
      this.hideSwatches = false
      this.setSwatchPage(this.pageOfActiveSwatch)
    }
  }

  _handleExperimentReady = () => {
    this.requestUpdate()
  }

  _handleFilterSwatchChanged = (swatch) => {
    this._setSwatchVariants()
    const firstMatch = this.swatchVariants.find((variant) =>
      variant.options.includes(swatch)
    )
    if (firstMatch) {
      this.setActiveByVariantId(firstMatch.id, true)
    }
  }

  _setSwatchVariants() {
    if (!this.swatches || !this.variants?.length) return []

    let nonColorOptions
    if (this.options?.length) {
      nonColorOptions = this.options.filter(
        (option) => !this.swatches.includes(option)
      )
    }
    const matches = this.swatches.reduce((accumulator, swatch) => {
      let match
      if (this.options?.length) {
        // if there are multiple options, ensure non color combos remain the same
        match = this.variants?.find((variant) => {
          for (const option of nonColorOptions) {
            if (!variant.options.includes(option)) return false
          }
          return variant.options.includes(swatch)
        })
      } else {
        match = this.variants?.find((variant) =>
          variant.options.includes(swatch)
        )
      }
      if (match) {
        const swatchHandle = handleize(swatch)
        const swatchColorConfig = __THEME_GLOBALS__?.swatches[swatchHandle]
        match.swatchTitle = swatch
        match.swatchHandle = swatchHandle
        match.swatchBackground1 = 'transparent'
        match.swatchBackground2 = 'transparent'
        if (swatchColorConfig) {
          if (swatchColorConfig[0]) {
            match.swatchBackground1 = swatchColorConfig[0]
          }
          if (swatchColorConfig[1]) {
            match.swatchBackground2 = swatchColorConfig[1]
          }
        }
        accumulator.push(match)
      }
      return accumulator
    }, [])
    this.swatchVariants = matches
  }

  _setSwatchCount() {
    this.swatchCount = this.options.find(
      (opt) => opt.name === 'Color'
    )?.values?.length
  }

  _handleLeftSwatchArrowClick() {
    this.setSwatchPage(this.activeSwatchPage - 1)
  }

  _handleRightSwatchArrowClick() {
    this.setSwatchPage(this.activeSwatchPage + 1)
  }

  _handlePaginationClick(e) {
    e.preventDefault()
    this.activeSlide = Number(e.currentTarget.dataset.index)
    this._setActiveSlide()
  }

  _setActiveSlide() {
    if (!this?.$slider?.value) return
    if (this.activeSlide === 0) {
      this.$slider.value.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    } else {
      this.$slider.value.scrollTo({
        top: 0,
        left: this.$slider.value.offsetWidth,
        behavior: 'smooth',
      })
    }
  }

  setActiveIndex(index) {
    this.activeIndex = index
  }

  setActiveByVariantId(id, setPage = false) {
    const variantIndex = this.swatchVariants.findIndex(
      (variant) => variant.id === parseInt(id, 10)
    )

    if (variantIndex > -1) {
      this.activeIndex = variantIndex
    }

    if (setPage) {
      const pageNumber = this.paginatedSwatches.findIndex((page) =>
        page.some((variant) => variant.id === parseInt(id, 10))
      )
      if (pageNumber > -1 && pageNumber !== this.activeSwatchPage) {
        this.setSwatchPage(pageNumber)
      }
    }
  }

  async setSwatchPage(pageNumber) {
    if (!this.swatchVariants?.length) return
    // Safety exit mechanism in case of miscalculated page number
    if (pageNumber > this.paginatedSwatches.length) {
      return
    }

    let tries = 0
    const interval = 100
    const maxTries = 20 // Gracefully fail after two seconds
    this._setSwatchesPosition(pageNumber)
    const checkInterval = setInterval(() => {
      if (this.$swatchesWrapper?.value?.clientWidth) {
        this._setSwatchesPosition(pageNumber)
        clearInterval(checkInterval)
      } else if (tries >= maxTries) {
        console.error('No swatch wrapper to set page for')
        clearInterval(checkInterval)
      }
      tries++
    }, interval)
  }

  _setSwatchesPosition(pageNumber) {
    const slideWidth = this.$swatchesWrapper?.value?.clientWidth || 0
    this.swatchesPosition = -slideWidth * pageNumber
    this.activeSwatchPage = pageNumber
  }

  _renderRatings() {
    if (this.rating) {
      return html` <a id="rating" href=${this.activeUrl} part="rating">
        ${this.rating.count > 0
          ? html` <sl-rating
                ${ref(this.$slRating)}
                label="Rating"
                value="${this.rating.average}"
                max="5"
                precision="0"
                readonly
              ></sl-rating
              ><span>(${this.rating.count})</span>`
          : `No Reviews Yet`}
      </a>`
    }
    return html`<slot name="ratings"></slot>`
  }

  render() {
    const isLimitedSwatches =
      window.__EXPERIMENT_FLAGS__?.limited_swatches === 'treatment'
    const isMobile =
      this.viewport?.startsWith('mobile') || window.innerWidth < 768
    const maxSwatchesToShow = isLimitedSwatches
      ? isMobile
        ? 3
        : 2
      : this.swatchVariants.length
    const visibleSwatches = this.swatchVariants.slice(0, maxSwatchesToShow)
    const remainingSwatchesCount = isLimitedSwatches
      ? Math.max(this.swatchVariants.length - maxSwatchesToShow, 0)
      : 0
    const arrowSvg = html`
      <svg
        width="8"
        height="12"
        viewBox="0 0 8 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.29006 0.710022C0.900059 1.10002 0.900059 1.73002 1.29006 2.12002L5.17006 6.00002L1.29006
           9.88002C0.900059 10.27 0.900059 10.9 1.29006 11.29C1.68006 11.68 2.31006 11.68 2.70006 11.29L7.29006
           6.70002C7.68006 6.31002 7.68006 5.68002 7.29006 5.29002L2.70006 0.700022C2.32006
            0.320022 1.68006 0.320022 1.29006 0.710022Z"
          fill="currentColor"
        />
      </svg>
    `
    return html`
      <div part="wrapper">
        <a
          href=${this.activeUrl}
          part="image-container"
          aria-label=${this.title}
          id="image-container"
        >
          ${this.visibleBadge
            ? html`<span
                id="badge"
                class="caption"
                part="badge"
                style=${styleMap(this.badgeStyleMap)}
                >${this.visibleBadge}</span
              >`
            : ''}
          ${this.imageHover
            ? html`<div
                part="image"
                id="image"
                class="image-hover"
                init="false"
              >
                <div
                  class="no-scrollbar justify-start flex gap-[0.125rem] snap-x snap-mandatory
                  overflow-x-scroll overscroll-x-none w-full aspect-square"
                  ${ref(this.$slider)}
                >
                  ${this.activeImage
                    ? html`<div
                        class="snap-start block h-full image-wrapper min-h-full aspect-square flex-shrink-0"
                      >
                        <img
                          src=${this.activeImage}
                          alt=${this.title}
                          loading=${this.imageLoading}
                          class="block w-full"
                        />
                      </div>`
                    : ''}
                  <div
                    class="snap-start block h-full image-wrapper min-h-full aspect-square flex-shrink-0"
                  >
                    <img
                      src=${this.imageHover}
                      alt=${this.title}
                      class="block w-full"
                    />
                  </div>
                </div>
                <div
                  class="pagination absolute right-[8px] bottom-2 left-[8px] z-[1] md:hidden"
                >
                  <div
                    class="flex items-center justify-start w-full gap-[10px]"
                  >
                    <button
                      class="w-[10px] h-[10px] rounded-full active:bg-primary bg-transparent border border-primary
                      cursor-pointer p-0 m-0 ${this.activeSlide === 0
                        ? 'active'
                        : ''}"
                      aria-label=${this.activeSlide === 0
                        ? 'Current Slide'
                        : 'Previous Slide'}
                      data-index="0"
                      @click=${this._handlePaginationClick}
                    ></button>
                    <button
                      class="w-[10px] h-[10px] rounded-full active:bg-primary bg-transparent border border-primary
                      cursor-pointer p-0 m-0 ${this.activeSlide === 0
                        ? ''
                        : 'active'}"
                      aria-label=${this.activeSlide === 0
                        ? 'Next Slide'
                        : 'Current Slide'}
                      data-index="1"
                      @click=${this._handlePaginationClick}
                    ></button>
                  </div>
                </div>
              </div>`
            : html`<div
                part="image"
                id="image"
                class="${this.imageHover ? 'image-hover' : ''}"
              >
                ${this.activeImage
                  ? html`<img
                      src=${this.activeImage}
                      alt=${this.title}
                      loading=${this.imageLoading}
                    />`
                  : ''}
                ${this.imageHover
                  ? html`<img src=${this.imageHover} alt=${this.title} />`
                  : ''}
              </div>`}
        </a>
        <div id="info" part="info">
          ${this.hideRatings ? '' : this._renderRatings()}
          <div id="details">
            <a href=${this.activeUrl} aria-label=${this.title}>
              <h1 class="h1" part="title">${this.title}</h1>
            </a>
            ${this.subtitle &&
            this.subtitle?.toLowerCase() !== 'default title' &&
            !this.options?.length
              ? html`
                  <a href=${this.activeUrl} aria-label=${this.title}>
                    <h2 class="h2">${this.subtitle}</h2>
                  </a>
                `
              : ''}
            ${!this.hidePrice
              ? this.activeMsrp
                ? html`
                    <a
                      href=${this.activeUrl}
                      aria-label=${window.__THEME_GLOBALS__.strings.viewPrice}
                      part="price"
                    >
                      ${window.__THEME_GLOBALS__.strings.viewPrice}
                    </a>
                  `
                : html`<div id="price" part="price">
                    ${this.activeCompareAtPrice
                      ? html`
                          <span class="price price--original line-through">
                            ${this.activeCompareAtPrice}
                          </span>
                          <span class="price price--sale"
                            >${this.activePrice}</span
                          >
                        `
                      : html` <span class="price">${this.activePrice}</span> `}
                    ${this.savingsAmount
                      ? html`<span
                          class="plp-savings-badge"
                          id="plp-savings-badge-${this.id}"
                        >
                          Save ${this.savingsAmount}
                        </span>`
                      : ''}
                    ${!this.activeAvailable
                      ? html`<p id="sold-out">Sold out</p>`
                      : ''}
                  </div>`
              : ''}
            ${!this.hidePrice &&
            this.activeMsrp &&
            this.activeMsrp !== 'undefined'
              ? html`
                  <span id="msrp" class="price price--msrp">
                    MSRP ${this.activeMsrp}
                  </span>
                `
              : ''}
            ${this.vendor && this.vendor?.toLowerCase() !== 'fellow'
              ? html` <span class="vendor">${this.vendor}</span> `
              : ''}
          </div>

          <div
            id="color-swatches-wrapper"
            ${ref(this.$swatchesWrapper)}
            ?hidden=${!this.swatchVariants.length || this.removeSwatches}
            class=${isLimitedSwatches ? 'is-limited' : ''}
          >
            ${this.options?.length
              ? html`<h2
                  class="h2 font-secondary ${isLimitedSwatches
                    ? 'swatch-title'
                    : ''}"
                >
                  ${this.swatchVariants[this.activeIndex]?.options.join(' | ')}
                </h2>`
              : html`
                  ${this.activeTitle
                    ? html`<h2
                        class="h2 font-secondary ${isLimitedSwatches
                          ? 'swatch-title'
                          : ''}"
                      >
                        ${this.activeTitle}
                      </h2>`
                    : ''}
                `}
            ${isLimitedSwatches
              ? html`
                  <div id="color-swatches" ?hidden=${this.hideSwatches}>
                    <ul id="color-swatches__items">
                      ${visibleSwatches.map(
                        (item) => html`
                          <li
                            class="swatch-container"
                            ?active=${this.activeId === item.id}
                          >
                            <button
                              aria-label="${item.title}"
                              href="${item.url}"
                              style="${styleMap({
                                background: item.swatchBackground1,
                                '--secondary-color': item.swatchBackground2,
                              })}"
                              class=${`swatch swatch--${item.swatchHandle} ${
                                !item.available ? 'swatch--sold-out' : ''
                              }`}
                              @click=${() =>
                                this.setActiveByVariantId(item.id)}
                            >
                              <span class="swatch__unavailable-cross"></span>
                              <span class="swatch__unavailable-cross"></span>
                            </button>
                          </li>
                        `
                      )}
                      ${remainingSwatchesCount > 0
                        ? html`
                            <li
                              class="swatch-count"
                              aria-label="${remainingSwatchesCount} more colors"
                            >
                              <a href=${this.activeUrl}
                                >+${remainingSwatchesCount}</a
                              >
                            </li>
                          `
                        : ''}
                    </ul>
                  </div>
                `
              : html`
                  <span
                    id="color-count"
                    class="caption color-subdued"
                    ?hidden=${!this.hideSwatches}
                  >
                    ${this.swatchVariants.length} colors
                  </span>
                  <div id="color-swatches" ?hidden=${this.hideSwatches}>
                    <div
                      id="color-swatches__items"
                      style="transform: translateX(${this.swatchesPosition}px)"
                    >
                      ${this.paginatedSwatches.map(
                        (pageItems, i) => html`
                          <ul class="color-swatch__page" data-page="${i}">
                            ${i > 0 && this.paginatedSwatches.length > 1
                              ? html` <li>
                                  <button
                                    @click=${this._handleLeftSwatchArrowClick}
                                    class="arrow fade"
                                    id="arrow--left"
                                    aria-label="Previous color options"
                                  >
                                    ${arrowSvg}
                                  </button>
                                </li>`
                              : ''}
                            ${pageItems.map(
                              (item) => html`
                                <li
                                  class="swatch-container"
                                  ?active=${this.activeId === item.id}
                                >
                                  <button
                                    aria-label="${item.title}"
                                    href="${item.url}"
                                    style="${styleMap({
                                      background: item.swatchBackground1,
                                      '--secondary-color':
                                        item.swatchBackground2,
                                    })}"
                                    class=${`swatch swatch--${item.swatchHandle} ${
                                      !item.available ? 'swatch--sold-out' : ''
                                    }`}
                                    @click=${() =>
                                      this.setActiveByVariantId(item.id)}
                                  >
                                    <span
                                      class="swatch__unavailable-cross"
                                    ></span>
                                    <span
                                      class="swatch__unavailable-cross"
                                    ></span>
                                  </button>
                                </li>
                              `
                            )}
                            ${i !== this.paginatedSwatches.length - 1
                              ? html`
                                  <li>
                                    <button
                                      @click=${this
                                        ._handleRightSwatchArrowClick}
                                      class="arrow fade"
                                      id="arrow--right"
                                      aria-label="Next color options"
                                    >
                                      ${arrowSvg}
                                    </button>
                                  </li>
                                `
                              : ''}
                          </ul>
                        `
                      )}
                    </div>
                  </div>
                `}
          </div>
          ${this.showSwatchesCount && this.swatchCount
            ? html`
                <span class="" part="count">
                  Available in ${this.swatchCount} colors
                </span>
              `
            : ''}
        </div>
      </div>
    `
  }

  static styles = [
    styles.reset,
    styles.a11y,
    styles.flex,
    styles.typography,
    styles.skeleton,
    styles.color,
    styles.animation,
    css`
      :host {
        display: flex;
        flex-direction: column;
        position: relative;
      }
      #badge {
        border-radius: 4px;
        padding: 4px 8px;
        position: absolute;
        top: 7px;
        right: 7px;
        z-index: 2;
      }

      .image-hover {
        position: relative;
      }

      .image-hover img {
        transition: cubic-bezier(0.4, 0, 0.2, 1) all 0.5s;
      }

      .no-scrollbar {
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none;
      }

      @media screen and (min-width: 768px) {
        swiper-container::part(pagination) {
          display: none !important;
        }

        swiper-container::part(container) {
          touch-action: none;
        }
        #badge {
          top: 10px;
          right: 10px;
        }

        .image-hover .image-wrapper + .image-wrapper img {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          object-fit: cover;
          width: 100%;
          height: 100%;
          opacity: 0;
        }

        .image-hover:hover img {
          opacity: 0;
        }

        .image-hover:hover .image-wrapper + .image-wrapper img {
          opacity: 1;
        }

        .image-hover {
          touch-action: none;
        }
      }
      .h1 {
        font-weight: 500;
        font-size: 18px;
        margin: 0;
        line-height: 21.6px;
      }
      .h2 {
        font-size: 14px;
        line-height: 16.8px;
        font-weight: 400;
        margin: 0 0 5px;
      }
      #image-container {
        aspect-ratio: 1/1;
        width: 100%;
        /* Safari aspect-ratio hack/fix */
        height: 0;
        padding-bottom: 100%;
        display: block;
      }
      #image {
        width: 100%;
        aspect-ratio: 1/1;
        background: linear-gradient(
          150.38deg,
          #dededa 3.74%,
          rgba(222, 222, 218, 0.491962) 63.73%,
          rgba(222, 222, 218, 0) 85.34%
        );
      }
      #image > div {
        overflow-anchor: none;
      }
      #image img,
      #image .skeleton {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      #info {
        padding: 8px;
        display: flex;
        flex-direction: column;
        gap: 9px;
      }
      @media screen and (min-width: 768px) {
        #info {
          padding: 20px;
        }
      }
      #details {
        display: flex;
        flex-direction: column;
        gap: 5px;
        justify-content: flex-start;
      }
      #rating {
        align-items: center;
        display: flex;
        gap: 10px;
        font-size: 14px !important;
        font-family: Inter, sans-serif !important;
      }
      #rating sl-rating {
        --symbol-size: 12px;
        --symbol-color-active: black;
        --symbol-color: black;
        --symbol-spacing: 0.5px;
        pointer-events: none;
      }
      #rating sl-rating::part(symbol-empty),
      #rating sl-rating::part(symbol-half) {
        --symbol-border-color: black;
        --symbol-border-width: 1px;
      }
      #color-swatches-wrapper {
        width: 100%;
        position: relative;
      }
      #color-swatches-wrapper.is-limited {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        flex-wrap: nowrap;
        gap: 12px;
        --swatch-size: 18px;
      }
      .swatch-title {
        display: inline-flex;
        margin: 0;
        min-width: 0;
      }
      #color-swatches {
        overflow: hidden;
        touch-action: pan-x;
      }
      #color-swatches__items {
        position: relative;
        opacity: 1;
        list-style: none;
        margin: 0;
        display: flex;
        flex-wrap: nowrap;
        transition:
          transform 400ms cubic-bezier(0.44, 0.65, 0.07, 1.01) 0s,
          opacity 0.2s;
        padding: 3px 0;
      }
      #color-swatches-wrapper.is-limited #color-swatches__items {
        gap: 6px;
      }
      @media screen and (min-width: 360px) {
        #color-swatches-wrapper.is-limited #color-swatches__items {
          gap: 10px;
        }
      }
      .color-swatch__page {
        display: flex;
        justify-content: flex-start;
        flex: 1;
        padding-left: 5px;
        gap: 10px;
        min-width: 100%;
      }
      @media screen and (min-width: 360px) {
        .color-swatch__page {
          gap: 16px;
        }
      }
      @media screen and (min-width: 768px) {
        .color-swatch__page {
          padding-left: 0;
        }
      }
      @media screen and (max-width: 767px) {
        #color-swatches-wrapper.is-limited {
          flex-direction: column;
          align-items: flex-start;
          gap: 6px;
          --swatch-size: 24px;
        }
      }
      @media screen and (min-width: 768px) {
        #color-swatches-wrapper.is-limited {
          display: flex !important;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          flex-wrap: nowrap;
        }
        #color-swatches-wrapper.is-limited {
          margin-top: -6px;
        }
        .swatch-title {
          flex: 1 1 auto;
          width: auto;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        #color-swatches {
          flex: 0 0 auto;
        }
      }
      .swatch {
        background: transparent;
        border-radius: 50%;
        cursor: pointer;
        display: block;
        width: var(--swatch-size);
        height: var(--swatch-size);
        transition: opacity 0.2s;
        border: 0.5px solid var(--color-dark-green, #35332b);
        overflow: hidden;
        position: relative;
      }
      .swatch:after {
        content: '';
        background-color: var(--secondary-color);
        display: block;
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 50%;
      }
      .swatch__unavailable-cross {
        position: absolute;
        left: 0;
        height: 1.5px;
        width: calc(100% - 1.2px);
        z-index: 3;
        display: block;
        top: 50%;
        transform: rotate(-45deg) translate(0.85px, -1.25px);
        background-color: #ffffff;
        display: none;
      }
      .swatch--sold-out .swatch__unavailable-cross {
        display: block;
      }
      .swatch--sold-out .swatch__unavailable-cross:last-child {
        transform: rotate(-45deg) translate(0.85px, -0.25px);
        width: calc(100% - 0.5px);
        background-color: black;
      }
      .swatch-container {
        border-radius: 50%;
        border: 1px solid transparent;
        padding: 2px;
      }
      #color-swatches-wrapper.is-limited .swatch-container {
        padding: 1px;
      }
      .swatch-container[active] {
        border: 1px solid var(--color-dark-green, #35332b);
      }
      .swatch-count {
        align-items: center;
        color: var(--color-dark-green, #35332b);
        display: inline-flex;
        font-size: 12px;
        font-weight: 500;
        line-height: 1;
      }
      .swatch-count a {
        color: inherit;
        text-decoration: none;
      }
      .arrow {
        align-items: center;
        background-color: transparent;
        color: var(--color-dark-green, #35332b);
        cursor: pointer;
        display: flex;
        width: 20px;
        height: 30px;
      }
      #arrow--left {
        transform: rotate(180deg);
      }
      .arrow svg {
        overflow: initial;
      }
      #price {
        align-items: center;
        font-size: 18px;
        display: flex;
        gap: 6px 10px;
        flex-wrap: wrap;
      }
      .price {
        font-family: 'PP Right Grotesk', sans-serif;
        font-weight: 500;
        line-height: 1.2;
      }
      .price--original,
      .price--msrp {
        color: #666;
      }
      .price--sale {
        color: var(--color-on-sale, #0400FF);
      }
      .price--msrp {
        font-family: 'Inter', sans-serif;
        font-size: 14px;
        margin-bottom: 6px;
      }
      #sold-out {
        color: #666;
        font-size: 14px;
        font-weight: 500;
        margin: 0;
        text-transform: capitalize;
      }
      .vendor {
        color: #666666;
        font-weight: 400;
        font-size: 14px;
      }
      .plp-savings-badge {
        background: #0400FF;
        padding: 1.5px 15px;
        font-size: 14px;
        color: white;
        font-weight: 500;
      }
    `,
  ]
}

customElements.define('hh-product-card', HHProductCard)
